import { SET_PAGE_DATA, SET_ACCOUNT_NAME } from './types';

export const setPage = (payload) => ({
	type: SET_PAGE_DATA,
	payload
});

export const setAccountName = (payload) => ({
	type: SET_ACCOUNT_NAME,
	payload
});
